import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { PolicyService } from '../services';
import { useHasPermission } from '../hooks/useHasPermission';

export const usePermissionsQuery = () => {
  const queryKey = ['permissions-key'];
  const canView = useHasPermission('policies:read:list');

  const queryFn = () => PolicyService.getAllPermissions();

  return useQuery({
    queryKey,
    queryFn,
    enabled: canView,
  });
};

export const usePoliciesQuery = () => {
  const queryKey = ['policies-key'];
  const canView = useHasPermission('policies:read:list');

  const queryFn = () => PolicyService.getAllPolicies();

  return useQuery({
    queryKey,
    queryFn,
    enabled: canView,
  });
};

export const forceRefreshPolicies = () => {
  queryClient.invalidateQueries(['policies-key']);
};
